export const appConfig = {
  application: "consumer",
  eyebrow: "Culture, measured in motion",
  title: "See the signal before it becomes the story.",
  description:
    "Track artists, releases, charts, and audience momentum through a calm, progressively streamed view of the Hallyu ecosystem.",
  localSignals: ["Chart velocity", "Audience growth", "Release momentum", "Cross-market reach"],
} as const;
